/**
 * Login feature strings.
 *
 * Namespace: login
 */
export const login = {
  // Page
  page: {
    title: "Bejelentkezés",
    subtitle: "Jelentkezzen be a fiókjába",
    subtitleReturn: "Jelentkezzen be a folytatáshoz",
    subtitleFirstLogin: "Első bejelentkezés",
    noAccount: "Nincs még fiókja?",
    createAccount: "Regisztráljon",
    forgotPassword: "Elfelejtett jelszó?",
    acceptPrivacyOnLoginPrefix: "A belépéssel elfogadom a mellékelt",
    acceptPrivacyOnLoginLink: "adatkezelési tájékoztatót",
  },

  // Email step
  email: {
    label: "Email cím",
  },

  // Whitelist check step
  whitelistCheck: {
    continue: "Tovább email címmel",
    error: "Hiba történt. Kérjük, próbálja újra.",
  },

  // Registration step
  register: {
    helperText: "Adja meg a nevét az aktiváló e-mail küldéséhez.",
    familyName: "Vezetéknév",
    familyNamePlaceholder: "pl. Kovács",
    givenName: "Keresztnév",
    givenNamePlaceholder: "pl. János",
    submit: "Aktiváló e-mail küldése",
    errors: {
      familyNameRequired: "A vezetéknév megadása kötelező.",
      givenNameRequired: "A keresztnév megadása kötelező.",
      apiError: "Hiba történt. Kérjük, próbálja újra.",
    },
  },

  // Sent step
  sent: {
    title: "E-mail elküldve!",
    bodyPrefix: "Elküldtük az aktiváló e-mailt a(z)",
    bodySuffix: "címre. Keresse meg a postaládájában, és kattintson az aktiválási linkre.",
    backToLogin: "Vissza a bejelentkezéshez",
  },

  // Form fields
  form: {
    emailLabel: "Email cím",
    emailPlaceholder: "pelda@example.com",
    passwordLabel: "Jelszó",
    passwordPlaceholder: "••••••••",
    submitButton: "Bejelentkezés",
    loadingButton: "Bejelentkezés...",
    enterPasswordFor: "Írja be a jelszavát ehhez a fiókhoz",
    editEmail: "Módosítás",
  },

  // ELTE login variant landing page
  elteLanding: {
    sectionAriaLabel: "Üdvözlő szöveg",
    welcome: "Üdvözöljük az ELTE LMS Support Assistant felületén.",
    descriptionIntro:
      "A chatalkalmazás a Gábor Dénes Mesterséges Intelligencia Tudásközpont és az Eötvös Loránd Tudományegyetem közös kísérleti kutatás-fejlesztési együttműködésének keretében jött létre azzal a céllal,",
    descriptionMiddle:
      "hogy demonstrálja a digitális asszisztensek alkalmazási lehetőségeit LMS felhasználói környezetben.",
    descriptionPurpose:
      "A rendszer célja, hogy támogatást nyújtson az oktatók számára a Moodle használatával kapcsolatos kérdésekben, a Canvas → Moodle átállási folyamatokban, valamint a tipikus használati és hibakeresési problémák kezelésében.",
  },

  // External login (IdP)
  external: {
    divider: "vagy",
    kreta: "Belépés Kréta-val",
    google: "Belépés Google-lel",
    elte: "Belépés",
    loadingButton: "Átirányítás...",
  },

  // OAuth callback page
  callback: {
    loadingTitle: "Bejelentkezés folyamatban",
    loadingMessage: "Kérjük, várjon egy pillanatot, miközben befejezzük a bejelentkezést.",
    errorTitle: "Sikertelen bejelentkezés",
    missingParamsError: "Hiányzó azonosító paraméterek. Kérjük, próbálja újra.",
    backToLogin: "Vissza a bejelentkezéshez",
  },

  // Errors
  errors: {
    recaptchaFailed: "reCAPTCHA ellenőrzés sikertelen. Kérjük, próbálja újra.",
    invalidCredentials:
      "Helytelen email cím vagy jelszó. Kérjük, ellenőrizze az adatokat és próbálja újra.",
    accountTemporarilyLocked: "A fiók átmenetileg zárolva van. Próbálkozzon újra később.",
    accountPermanentlyLocked: "A fiók zárolva van. Keresse az adminisztrátort.",
    externalLoginFailed: {
      google: "Nem sikerült belépni Google fiókkal. Kérjük, próbálja újra.",
      kreta: "Nem sikerült belépni Kréta fiókkal. Kérjük, próbálja újra.",
      elte: "Nem sikerült belépni ELTE fiókkal. Kérjük, próbálja újra.",
      default: "Nem sikerült a külső bejelentkezés. Kérjük, próbálja újra.",
    },
  },

  // Success
  success: {
    title: "Sikeres bejelentkezés",
    message: "Sikeresen bejelentkezett. Bezárhatja ezt az ablakot.",
  },
} as const;
